import { AxiosResponse } from "axios";
import { getAxiosInstance } from "./axiosConfig";

const axiosInst = getAxiosInstance(localStorage.getItem("WIS_API_URL") || "");

export async function populateMasterData(): Promise<AxiosResponse<unknown>> {
  const result = await axiosInst.post("/api/Management/populatemasterdata");
  return result;
}
